// extracted by mini-css-extract-plugin
export default {"block":"our-news-page_block__0jvL2","info":"our-news-page_info__-CjPQ","filterNews":"our-news-page_filterNews__Y7xN-","select":"our-news-page_select__3Yub8"};